import React, {useEffect, useState} from 'react';
import {getUserProducts} from "../../services/ProductRepository";
import {HomeSidebar} from "../../components/navigation/HomeSidebar";
import {SimpleGrid} from "../../components/SimpleGrid";
import {ProductItem} from "../product/ProductItem";
import {useError} from "../../hooks/useError";
import Header from "../../components/navigation/Header";
import {Link} from "react-router-dom";
import {routes} from "../../utils/Routes";
import {PiSmileySadBold} from "react-icons/pi";
import {TbArrowsDiagonal2} from "react-icons/tb";


export function HomeDashboard() {
    const [products, setProducts] = useState(null);
    const {setErrorMessage} = useError()

    useEffect(() => {
        if (products == null) {
            getUserProducts(setErrorMessage).then(result => {
                setProducts(result);
            }).catch(err => console.log(err));
        }
    }, []);

    if (products != null) {

        if (products.length === 0) {
            return (
                <div>
                    <Header></Header>
                    <div className={"container p-5 d-flex flex-column align-items-center justify-content-center"} style={{minHeight:"80vh"}}>
                        <PiSmileySadBold size={64} className={"text-muted mb-3"}/>
                        <h3>Du eier foreløpig ingen produkter</h3>
                        <Link to={"/butikk"} className={"btn btn-primary text-white mt-3"}>
                            Bla gjennom kurs
                        </Link>
                    </div>
                </div>
            )
        }

        return (
            <div className={"bg-light "} style={{minHeight:"100vh"}}>
                <Header/>
                <div className={"container p-5 "}>
                    <div className={""}>
                        <SimpleGrid fill rowSize={2}>
                            {
                                products.map(item => (
                                    <div className={"border border-2 rounded p-3 px-4 bg-white me-3"}>
                                        <div className={"badge bg-warning mb-2"}>{item.productType}</div>
                                        <h3 className={"fw-bold"}>{item.name}</h3>
                                        <p className={"text-muted text-justify pe-3"}>{item.slug}</p>
                                        <Link to={routes.productHomeAbs(item.name)} className={"btn btn-dark"}>
                                            <TbArrowsDiagonal2 size={24} className={"me-2"}/>
                                            <label>Gå til kurs</label>
                                        </Link>
                                    </div>
                                ))
                            }

                        </SimpleGrid>

                    </div>

                </div>

            </div>

        );
    }


}